/*
 * Shared global namespace bootstrap for legacy bundles.
 *
 * Every legacy finder module imports this file itself. Vite hoists eager
 * import.meta.glob members above the imports around a glob, so an entrypoint
 * import is not enough to guarantee this runs before a glob member.
 */
window.Sparkle ??= {};

window.DoctorFinder ??= {};
window.DoctorFinder.Models ??= {};
window.DoctorFinder.Collections ??= {};
window.DoctorFinder.Helpers ??= {};
window.DoctorFinder.Templates ??= {};
window.DoctorFinder.Views ??= {};
window.DoctorFinder.Serializers ??= {};
const doctorFinderEvents = {
  wizard: {
    slotPick: "wizard:slotPicked",
    filterFocusClicked: "wizard:filterFocusClicked",
    removeFilterClicked: "wizard:removedFilterClicked",
  },
};

window.DoctorFinder.Events ??= doctorFinderEvents;

const views = window.DoctorFinder.Views;
views.Autocomplete ??= {};
views.ListResults ??= {};
views.WizardStep1 ??= {};
views.WizardStep2 ??= {};
